export default (o1, o2) => !!o1 && !!o2;

